import React from "react";
import Oracle from "../assets/images/Oracle.png";
import IBM from "../assets/images/IBM.png";
import Google from "../assets/images/Google.png";
import Microsoft from "../assets/images/Microsoft.png";
import icebergLogo from "../assets/images/icebergLogo.png";
import sitemark from "../assets/images/sitemark.png";
import hitech from "../assets/images/hitech.jpeg";

import ResumeIcon from "../assets/images/resume.svg";
import MatchIcon from "../assets/images/time.svg";
import NotifyIcon from "../assets/images/notifications.svg";

// ✅ Company logos that are properly imported
const companies = [
  { name: "Oracle", logo: Oracle },
  { name: "IBM", logo: IBM },
  { name: "Google", logo: Google },
  { name: "Microsoft", logo: Microsoft },
  { name: "Hitech", logo: hitech },
  { name: "Sitemark", logo: sitemark },
  { name: "ICEBERG", logo: icebergLogo },
];

export default function CompanySection() {
  return (
    <section className="w-full px-4 md:px-24 py-16 text-center overflow-hidden bg-white">
      <p className="text-2xl font-semibold text-[#fc3c04] mb-10">
        These companies work with <span className="text-[#345bf3]"> us to make us grow</span>
      </p>

      {/* Auto-scrolling Marquee */}
      <div className="relative w-full overflow-hidden mb-16">
        <div
          className="flex gap-10 whitespace-nowrap"
          style={{
            animation: "scrolling 20s linear infinite",
          }}
        >
          {[...companies, ...companies].map((company, index) => (
            <img
              key={index}
              src={company.logo}
              alt={`${company.name} logo`}
              className="h-15 inline-block opacity-80 hover:opacity-100 transition-opacity duration-200"
            />
          ))}
        </div>

        {/* Inline Keyframes */}
        <style>
          {`
            @keyframes scrolling {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>
      </div>

   

      {/* Main Heading */}
      {/* <h1 className="text-2xl md:text-4xl font-bold text-[#2B3DA8] leading-tight mb-12">
        The Only Job Seeker <br />
        Centric Platform
      </h1> */}

      {/* Feature Cards */}
      {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left max-w-7xl mx-auto">

        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src={ResumeIcon} alt="Resume Icon" className="w-7 h-7" />
            <h3 className="font-semibold text-[#2B3DA8] text-base md:text-lg">
              Create your resume
            </h3>
          </div>
          <div className="border-b border-gray-200 mb-4"></div>
          <p className="text-gray-600 text-sm leading-relaxed text-justify">
            Creating your resume is an essential step in showcasing your skills,
            experience, and qualifications to potential employers.
          </p>
        </div>

    
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src={MatchIcon} alt="Match Icon" className="w-7 h-7" />
            <h3 className="font-semibold text-[#2B3DA8] text-base md:text-lg">
              Get matched in minutes
            </h3>
          </div>
          <div className="border-b border-gray-200 mb-4"></div>
          <p className="text-gray-600 text-sm leading-relaxed text-justify">
            "Get matched in minutes" refers to the quick and efficient process
            of connecting individuals with the right opportunities, services, or people.
          </p>
        </div>

   
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src={NotifyIcon} alt="Notify Icon" className="w-7 h-7" />
            <h3 className="font-semibold text-[#2B3DA8] text-base md:text-lg">
              Never miss an opportunity
            </h3>
          </div>
          <div className="border-b border-gray-200 mb-4"></div>
          <p className="text-gray-600 text-sm leading-relaxed text-justify">
            "Never miss an opportunity" emphasizes the importance of staying
            alert and ready for new chances that can lead to growth and success.
          </p>
        </div>
      </div> */}
    </section>
  );
}
